<template>
    <div class="activity-terms">
        <Translation
            class="activity-terms-description"
            :translate="{ key: 'cancellation.cancellation_policy_terms' }" />
        <Divider color="lightGrey" thickness="1" topMargin="xxl" bottomMargin="xl" />
        <div class="activity-terms-cart-cancellation">
            <CartCancellation :product="product" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import CartCancellation from '@/components/shared/Cancellation/CartCancellation/CartCancellation.vue';
    import Translation from '@ui/components/Translation/Translation.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'Terms',
        components: {
            Divider,
            Translation,
            CartCancellation,
        },
        props: {
            product: {
                type: Object as PropType<ActivityProduct>,
                required: true,
            },
        },
    });
</script>

<style scoped lang="scss">
    @forward 'Terms';
</style>
